(function() {
  'use strict';

  angular.module('app').factory('FeedbackService', FeedbackService);

  FeedbackService.$inject = ['$rootScope', 'API', 'NotifyService'];

  function FeedbackService($rootScope, API, NotifyService) {
    var service = {};

    service.possibleCustomerActions = [
      {title: 'only vote', value: 'rate-only'},
      {title: 'only feedback', value: 'review-only'},
      {title: 'vote or feedback', value: 'rate-or-review'},
      {title: 'mandatory vote and feedback', value: 'rate-and-review'}
    ];

    service.getFeedbackList = function(params, callback) {
      var url = '/customer_feedback/feedbacks?{0}'.format(paramsToUrlQueryEncodeURIComponent(params));
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    service.getFeedbackInfo = function(feedback_id, callback) {
      var url = '/customer_feedback/feedbacks/{0}'.format(feedback_id);
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    service.markFeedbackReaded = function(feedback_id, data, callback) {
      var url = '/customer_feedback/feedbacks/{0}/readed'.format(feedback_id);
      API.patch(url, data, function(success, data) {
        callback(success, data);
      });
    };

    service.getFeedbackAttachment = function(feedback_id, attachment_id, callback) {
      var url = '/customer_feedback/feedbacks/{0}/attachments/{1}'.format(feedback_id, attachment_id);
      API.get(url, function(success, data) {
        callback(success, data);
      }, false, {responseType: 'blob'});
    };

    service.getFeedbackSources = function(loyalty_id, params, callback) {
      var url = '/customer_feedback/loyalty/{0}/feedback_sources?{1}'.format(loyalty_id, paramsToUrlQueryEncodeURIComponent(params));
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    service.getFeedbackSourceData = function(loyalty_id, id, callback) {
      var url = '/customer_feedback/loyalty/{0}/feedback_sources/{1}'.format(loyalty_id, id);
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    service.getFeedbackSettings = function(loyalty_id, callback) {
      var url = '/customer_feedback/loyalty/{0}/settings'.format(loyalty_id);
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    service.addFeedbackSource = function(loyaltyId, data, callback) {
      var url = '/customer_feedback/loyalty/{0}/feedback_sources'.format(loyaltyId);
      API.post(url, data, function(success, data) {
        callback(success, data);
      });
    };

    service.changeFeedbackSource = function(loyaltyId, id, data, callback) {
      var url = '/customer_feedback/loyalty/{0}/feedback_sources/{1}'.format(loyaltyId, id);
      API.patch(url, data, function(success, data) {
        if (success) {
          NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };

    service.modifyLoyaltyCustomerFeedbackSettings = function(loyaltyId, data, callback) {
      var url = '/customer_feedback/loyalty/{0}/settings'.format(loyaltyId);
      API.patch(url, data, function(success, data) {
        callback(success, data);
      });
    };

    service.removeCustomerFeedback = function(feedback_id, callback) {
      var url = '/customer_feedback/feedbacks/{0}'.format(feedback_id);
      API.del(url, function(success, data) {
        callback(success, data);
      });
    };

    service.getFeedbackPOSSettings = function(pos_id, callback) {
      var url = '/customer_feedback/pos/{0}/settings'.format(pos_id);
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    service.changeFeedbackPOSSettings = function(pos_id, data, callback) {
      var url = '/customer_feedback/pos/{0}/settings'.format(pos_id);
      API.patch(url, data, function(success, data) {
        callback(success, data);
      });
    };

    service.getFeedbackTerminalSettings = function(register_id, callback) {
      var url = '/customer_feedback/terminal/{0}/settings'.format(register_id);
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    service.changeFeedbackTerminalSettings = function(register_id, data, callback) {
      var url = '/customer_feedback/terminal/{0}/settings'.format(register_id);
      API.patch(url, data, function(success, data) {
        callback(success, data);
      });
    };

    return service;
  }
})();
